<template>
  <nav class="side-nav" aria-label="Navegación principal">
    <RouterLink
      to="/"
      class="side-nav__link"
      active-class="side-nav__link--active"
      exact-active-class="side-nav__link--active"
    >
      <svg
        class="side-nav__icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M4 11.5 12 4l8 7.5"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 10v9a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-9"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        />
      </svg>
      Inicio
    </RouterLink>

    <RouterLink
      v-if="authStore.user?.nickname"
      :to="{ name: 'profile', params: { nickname: authStore.user.nickname } }"
      class="side-nav__link"
      active-class="side-nav__link--active"
    >
      <svg
        class="side-nav__icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M6 4h9l5 5v11a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        />
        <path
          d="M9 12h6M9 16h6"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
        />
      </svg>
      Mis frases
    </RouterLink>

    <RouterLink
      v-if="authStore.isAuthenticated"
      :to="{ name: 'manage-catalog' }"
      class="side-nav__link"
      active-class="side-nav__link--active"
    >
      <svg
        class="side-nav__icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M6 4h12v16l-6-3-6 3V4z"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
        />
      </svg>
      Gestionar catálogo
    </RouterLink>
  </nav>
</template>

<script setup>
import { useAuthStore } from "@/store/auth";

const authStore = useAuthStore();
</script>

<style scoped>
/*
 * "position: fixed" y anclado al centro de la pantalla (misma técnica que
 * el botón "nueva frase" en CreateQuote.vue): así el menú se posiciona a
 * la izquierda del feed centrado sin formar parte del flujo del layout.
 * Si estuviera en flujo (flex junto al contenido), el contenido se
 * centraría en el hueco restante en vez de en la pantalla completa,
 * quedando desplazado hacia la derecha.
 *
 * Solo visible en pantallas anchas (con hueco de sobra a ambos lados del
 * feed centrado, 620px); en resoluciones menores no cabe, así que "Mis
 * frases" se mantiene accesible desde el desplegable de usuario (ver
 * UserMenu.vue).
 */
.side-nav {
  position: fixed;
  top: 96px;
  left: max(20px, calc(50% - 310px - 32px - 220px));
  width: 220px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.side-nav__link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 10px;
  text-decoration: none;
  color: var(--ink);
  font-weight: 600;
  font-size: 15px;
}

.side-nav__link:hover {
  background: var(--paper-deep);
}

.side-nav__link--active {
  background: var(--paper-deep);
  color: var(--melon-deep);
}

.side-nav__icon {
  flex-shrink: 0;
}

/*
 * Umbral más ancho que en otros componentes: con 620px de feed centrado +
 * 220px de menú + hueco, hace falta bastante más viewport que en el caso
 * del botón "nueva frase" para que quepan los dos lados sin solaparse.
 */
@media (max-width: 1150px) {
  .side-nav {
    display: none;
  }
}
</style>